import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ResendTicketsRequest {
  docType: string;
  docNumber: string;
  travelDate: string;
  purchaseEmail: string;
  destinationEmail: string;
}

export interface RefundTicketsRequest {
  docType: string;
  docNumber: string;
  travelDate: string;
  email?: string;
  ticketNumber?: string;
  refundCode?: string;
}

export interface TicketResponse {
  success: boolean;
  message: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private http: HttpClient) { }

  searchTickets(request: any): Observable<TicketResponse> {
    return this.http.post<TicketResponse>(
      `${environment.backendApiUrl}/tickets/search`,
      request
    );
  }

  /**
   * Reenvía tickets por email
   * @param request Datos para reenviar tickets
   * @returns Observable con la respuesta
   */
  resendTicket(id: number, operationId: number, request: any): Observable<any> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/operations/${operationId}/tickets/${id}/email`,
      request
    );
  }

  /**
   * Procesa la devolución de tickets
   * @param request Datos para devolver tickets
   * @returns Observable con la respuesta
   */
  refundTickets(request: RefundTicketsRequest): Observable<TicketResponse> {
    return this.http.post<TicketResponse>(
      `${environment.backendApiUrl}/tickets/refund`,
      request
    );
  }

  validarBoleto(providerAlias: string, boleto: string, ticket: string, empresa: string, metodo: string): Observable<any> {
    //https://providers.zonapasajes.com.ar/services/la20/validate-ticket/?boleto=ZOP-205&ticket=1871279&empresa=1&metodo=devolver
    return this.http.get<any>(
      `${environment.providersApiUrl}/services/${providerAlias}/validate-ticket/?boleto=${boleto}&ticket=${ticket}&empresa=${empresa}&metodo=${metodo}`,
    );
  }

  devolverBoleto(providerAlias: string, operationId: number, boleto: string, ticket: string, empresa: string): Observable<any> {
    //https://providers.zonapasajes.com.ar/services/la20/validate-ticket/?boleto=ZOP-205&ticket=1871279&empresa=1
    return this.http.post<any>(
      `${environment.providersApiUrl}/services/${providerAlias}/full-cancel-ticket`,
      {
        operationId: operationId,
        boleto: boleto,
        ticket: ticket,
        empresa: empresa
      }
    );
  }

}

